<template>
  <div class="menu-wrapper">
    <template v-for="item in routes">
      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children" :to="item.path+'/'+item.children[0].path"
                   :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path">
          <span slot="title"><svg-icon :icon-class="item.children[0].meta.icon" />{{item.children[0].meta.title}}</span>
        </el-menu-item>
      </router-link>
    </template>
    <!--<router-link to="/user">-->
      <!--<el-menu-item index="2">-->
        <!--<span slot="title">用户管理</span>-->
      <!--</el-menu-item>-->
    <!--</router-link>-->
    <!--<router-link to="/role">-->
      <!--<el-menu-item index="3" >-->
        <!--<span slot="title">角色管理</span>-->
      <!--</el-menu-item>-->
    <!--</router-link>-->
    <!--<router-link to="/menu">-->
      <!--<el-menu-item index="4">-->
        <!--<span slot="title">菜单管理</span>-->
      <!--</el-menu-item>-->
    <!--</router-link>-->
  </div>
</template>

<script>
export default {
  name: 'sidebar-item',
  props: {
    routes: {
      type: Array
    }
  },
  methods: {
    hasOneShowingChildren (children) {
      if (!children) {
        return false
      }
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue